"use client"

import { useQuery } from "@tanstack/react-query"
import type { PlanHistory } from "@/lib/billing/plans/plan-history"
import { getBillingPlanHistoryAction } from "@/server-actions/billing-plan-history"

export function useBillingPlanHistoryQuery(planId: string) {
  return useQuery<PlanHistory>({
    queryKey: ["billing", "plan-history", planId],
    // Saves happen outside React Query; the global 60s staleTime would hide them.
    staleTime: 0,
    refetchOnMount: "always",
    queryFn: async () => {
      const result = await getBillingPlanHistoryAction({ planId })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
